import React, { useContext, useEffect, useState } from "react";
import styles from "./Cart.module.scss";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../../stores/RootStore";
import { useSearchParams } from "react-router-dom";
import OzonLogo from "assets/icons/ozon.png";
import WildberriesLogo from "assets/icons/wildberries.png";
import { OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import YandexLogo from "../../../assets/icons/yandex.png";
import toast from "react-hot-toast";
import Modal from "components/Modal";
import moment from "moment";
import Button from "components/Button";

const CartShipmentActs: React.FC = observer(() => {
  const {
    orderStore: { getOrdersCount },
    wildberriesStore: { getWildberriesShipmentAct },
    yandexStore: { getYandexShipmentAct },
    ozonStore: { getOzonShipmentAct },
    userStore: { info, userInfo },
  } = useContext(RootStoreContext);

  const [yandexOrdersCount, setYandexOrdersCount] = useState<string>("");
  const [ozonOrdersCount, setOzonOrdersCount] = useState<string>("");
  const [wildberriesOrdersCount, setWildberriesOrdersCount] =
    useState<string>("");

  const [searchParams, setSearchParams] = useSearchParams();

  const [modalMarketplace, setModalMarketplace] = useState<number | null>(null);

  const [startDate, setStartDate] = useState<string>(
    moment().subtract(1, "days").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState<string>(moment().format("YYYY-MM-DD"));

  const seller = searchParams.get("seller");
  const mpWarehouseID =
    info?.roles.includes("WarehouseOwner") && !info?.roles.includes("Seller")
      ? Number(userInfo?.mpWarehouseID).toString()
      : searchParams.get("mpWarehouseID");
  const marketplace = searchParams.get("marketplace");

  useEffect(() => {
    if (seller) {
      setOzonOrdersCount("");
      setWildberriesOrdersCount("");
      setYandexOrdersCount("");

      if (mpWarehouseID) {
        getOrdersCount(seller, 1, +mpWarehouseID).then((i) => {
          setOzonOrdersCount(i);
        });
        getOrdersCount(seller, 2, +mpWarehouseID).then((i) => {
          setYandexOrdersCount(i);
        });
        getOrdersCount(seller, 3, +mpWarehouseID).then((i) => {
          setWildberriesOrdersCount(i);
        });
      }
    }
  }, [getOrdersCount, mpWarehouseID, seller]);
  return (
    <>
      {seller && mpWarehouseID && Number(marketplace) === 2 ? (
        <div
          className={styles.marketPlacesLogo}
          onClick={() => {
            getYandexShipmentAct(seller, +mpWarehouseID).then((i) => {
              if (i) {
                const a = document.createElement("a");
                a.href = window.URL.createObjectURL(new Blob([i]));
                a.download = "yandexShipmentAct.pdf";
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
              } else {
                toast.error("Акт отгрузки отсутствует");
              }
            });
          }}
        >
          <OverlayTrigger overlay={<Tooltip>Скачать акт отгрузки</Tooltip>}>
            <div>
              <img src={YandexLogo} alt="yandex market logo" />
              <span>({yandexOrdersCount})</span>
            </div>
          </OverlayTrigger>
        </div>
      ) : (
        ""
      )}
      {seller && mpWarehouseID && Number(marketplace) === 1 ? (
        <div
          className={styles.marketPlacesLogo}
          onClick={() => {
            getOzonShipmentAct(seller, +mpWarehouseID).then((i) => {
              if (i) {
                const a = document.createElement("a");
                a.href = window.URL.createObjectURL(new Blob([i]));
                a.download = "ozonShipmentAct.pdf";
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
              } else {
                toast.error("Акт отгрузки отсутствует");
              }
            });
          }}
        >
          <OverlayTrigger overlay={<Tooltip>Скачать акт отгрузки</Tooltip>}>
            <div>
              <img src={OzonLogo} alt="ozon market logo" />
              <span>({ozonOrdersCount})</span>
            </div>
          </OverlayTrigger>
        </div>
      ) : (
        ""
      )}
      {seller && mpWarehouseID && Number(marketplace) === 3 ? (
        <div
          className={styles.marketPlacesLogo}
          onClick={() => {
            setModalMarketplace(Number(marketplace));
          }}
        >
          <OverlayTrigger overlay={<Tooltip>Скачать акт отгрузки</Tooltip>}>
            <div>
              <img src={WildberriesLogo} alt="wildberries market logo" />
              <span>({wildberriesOrdersCount})</span>
            </div>
          </OverlayTrigger>
        </div>
      ) : (
        ""
      )}

      {modalMarketplace && seller && mpWarehouseID && (
        <Modal
          className={styles.cartModal}
          children={
            <div className={styles.dateModalRoot}>
              <div className={styles.dates}>
                <div>
                  <div>Период</div>
                  <div>
                    от:
                    {
                      <input
                        type="date"
                        value={startDate}
                        onChange={(e) => {
                          setStartDate(e.target.value);
                        }}
                      />
                    }
                  </div>

                  <div>
                    до:
                    {
                      <input
                        type="date"
                        value={endDate}
                        onChange={(e) => {
                          setEndDate(e.target.value);
                        }}
                      />
                    }
                  </div>
                </div>
              </div>
              <Button
                text="Скачать"
                color="primary"
                className={styles.payButton}
                onClick={() => {
                  switch (modalMarketplace) {
                    case 3:
                      getWildberriesShipmentAct(
                        seller,
                        +mpWarehouseID,
                        startDate,
                        endDate
                      ).then((i) => {
                        if (i) {
                          const a = document.createElement("a");
                          a.href = window.URL.createObjectURL(new Blob([i]));
                          a.download = "wildberriesShipmentAct.pdf";
                          document.body.appendChild(a);
                          a.click();
                          document.body.removeChild(a);
                        } else {
                          toast.error("Акт отгрузки отсутствует");
                        }
                      });
                      break;
                    default:
                  }
                }}
              />
            </div>
          }
          isOpen={modalMarketplace !== null}
          onClose={() => {
            setModalMarketplace(null);
          }}
        />
      )}
    </>
  );
});
export default CartShipmentActs;
